<template>
  <v-container>
    <div class="flex-column d-flex" :style="{ gap: '10px' }">
      <div>
        <v-text-field outlined hide-details="auto" label="Email" type="email" :value="inputs.email"
                      :error-messages="errors.email" @change="v => setInputs('email', v)" />
      </div>
      <div>
        <v-text-field outlined hide-details="auto" label="Password" type="password" :value="inputs.password"
                      :error-messages="errors.password" @change="v => setInputs('password', v)" />
      </div>
      <div>
        <v-btn color="warning" class="black--text" dark block :loading="loading" @click="submit">
          <span>Update</span>
        </v-btn>
      </div>
      <div>
        <v-btn color="error" dark block :loading="loading" @click="close">
          <span>Cancel</span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import { isAxiosError } from 'axios'
import { authAxios } from '../../../../../extra-functions/axios.extra'
import { ConfirmPopup, ErrorPopup, LoadingPopup, SuccessPopup, useWatchEffect } from '../../../../../lib/utils'

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'EditConsumerUser',
  data() {
    return {
      consumerId: null,
      inputs: {
        email: null,
        password: null,
      },
      errors: {},
      loading: false,
    }
  },
  beforeDestroy() {
    clearWatchEffect()
  },
  methods: {
    async submit() {
      try {
        if (!this.consumerId) throw new Error('consumer is not selected')
        const { isConfirmed } = await ConfirmPopup.fire('Confirm', 'Are you sure you want to update this user?')
        if (!isConfirmed) return

        LoadingPopup.fire('Saving', 'Saving user on the server...')
        const { data } = await authAxios().put(`/v2/consumer-users/${this.consumerId}`, {
          ...this.inputs,
        })

        SuccessPopup.fire('Success', data?.message || 'User successfully updated')
        this.$emit('success')
        this.close()
      } catch (e) {
        LoadingPopup.close()
        if (isAxiosError(e) && e.status === 422) {
          const { errors = {} } = e.response.data ?? {}
          this.errors = errors
          return
        }
        console.error(e)
        ErrorPopup.fire('Oops', 'Something went wrong')
      }
    },
    fetchConsumerUser() {
      watchEffect(async (onCleanup) => {
        try {
          if (!this.consumerId) return
          const controller = new AbortController()
          onCleanup(() => controller.abort())
          LoadingPopup.fire('Loading', 'Getting User...')
          const { data } = await authAxios().get(`/v2/consumer-users/${this.consumerId}/edit`, {
            signal: controller.signal,
          })
          this.inputs = {
            ...this.inputs,
            email: data.data.email,
          }
          LoadingPopup.close()
        } catch (e) {
          console.error(e)
          ErrorPopup.fire('Error', 'Oops something went wrong')
        }
      }, 'EditConsumerUser_fetchConsumerUser')
    },
    setConsumerId(consumerId) {
      this.consumerId = consumerId
    },
    setInputs(key, value) {
      this.inputs = {
        ...this.inputs,
        [key]: value,
      }
    },
    close() {
      this.$emit('close')
      this.inputs.consumerId = null
      this.inputs.email = null
      this.inputs.password = null
    },
  },
}
</script>